import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslate} from 'react-redux-multilingual';
import {TbArrowRight} from 'react-icons/tb';
import Picture from '../cpr/Picture';
import Reveal from '../cpr/Reveal';

export function CommissionStatement() {
    const t = useTranslate();
    return (
        <section className="cpr-section cpr-commission" aria-labelledby="cpr-commission-title">
            <div className="cpr-container cpr-commission__grid">
                <Reveal className="cpr-commission__figure cpr-num" aria-hidden="true">0%</Reveal>
                <Reveal delay={120}>
                    <h2 id="cpr-commission-title" className="cpr-h2">{t('no_commission_title')}</h2>
                    <p className="cpr-lead cpr-commission__text">{t('aboutUsInfo1')}</p>
                    <Link to="/about-us" className="cpr-link">
                        {t('about_us')}<TbArrowRight aria-hidden="true"/>
                    </Link>
                </Reveal>
            </div>
        </section>
    );
}

const BAGHRAMYAN_FEATURES = [1, 2, 3, 4, 5, 6, 7, 8].map(n => `new_amenities_${n}`);

export function Projects({figures}) {
    const t = useTranslate();
    return (
        <section className="cpr-section cpr-projects" aria-labelledby="cpr-projects-title">
            <div className="cpr-container">
                <h2 id="cpr-projects-title" className="cpr-h2 cpr-projects__title">{t('projects_title')}</h2>

                <div className="cpr-projects__grid">
                    <Reveal as="article" className="cpr-project">
                        <div className="cpr-media cpr-media--cutout">
                            <picture>
                                <source type="image/webp"
                                        srcSet="/assets/images/cpr/arabkir-cutout-768.webp 768w, /assets/images/cpr/arabkir-cutout-1537.webp 1537w"
                                        sizes="(min-width: 1024px) 40vw, 100vw"/>
                                <img src="/assets/images/building/building.png" alt={t('aboutBuilding')}
                                     width="1537" height="978" loading="lazy" decoding="async"/>
                            </picture>
                        </div>
                        <div className="cpr-project__body">
                            <h3 className="cpr-h3">{t('aboutBuilding')}</h3>
                            <div className="cpr-body">
                                <p>{t('aboutBuildingInfo1')}</p>
                                <p>{t('aboutBuildingInfo2')}</p>
                            </div>
                            <div className="cpr-project__actions">
                                <Link to="/arabkir" className="cpr-btn cpr-btn--primary">{t('select_apartment')}</Link>
                                <Link to="/info" className="cpr-link">
                                    {t('building_details')}<TbArrowRight aria-hidden="true"/>
                                </Link>
                            </div>
                        </div>
                    </Reveal>

                    <Reveal as="article" className="cpr-project" delay={120}>
                        <div className="cpr-media">
                            <Picture name="baghramyan-front" alt={t('aboutBaghramyanBuilding')}
                                     sizes="(min-width: 1024px) 50vw, 100vw"/>
                        </div>
                        <div className="cpr-project__body">
                            <h3 className="cpr-h3">{t('aboutBaghramyanBuilding')}</h3>
                            <div className="cpr-body">
                                <p>{t('aboutBaghramyanBuildingInfo1')}</p>
                                <p>{t('aboutBaghramyanBuildingInfo2')}</p>
                            </div>
                            <ul className="cpr-project__features">
                                {BAGHRAMYAN_FEATURES.map(key => <li key={key}>{t(key)}</li>)}
                            </ul>
                        </div>
                    </Reveal>
                </div>

                {figures}
            </div>
        </section>
    );
}

const AMENITY_TILES = [
    {image: 'courtyard-lounge', caption: 'albumZoomText1', size: 'lg'},
    {image: 'terrace', caption: 'albumZoomText2', size: 'md'},
    {image: 'lobby', caption: 'albumZoomText4', size: 'sm'},
    {image: 'parking', caption: 'albumZoomText3', size: 'sm'},
];

const AMENITY_LIST = [1, 2, 3, 4, 5, 6, 7, 8].map(n => `amenities_${n}`);

export function Amenities() {
    const t = useTranslate();
    return (
        <section className="cpr-section cpr-section--surface cpr-amenities" aria-labelledby="cpr-amenities-title">
            <div className="cpr-container">
                <div className="cpr-amenities__head">
                    <h2 id="cpr-amenities-title" className="cpr-h2">{t('amenities_title')}</h2>
                    <ul className="cpr-amenities__list">
                        {AMENITY_LIST.map(key => <li key={key}>{t(key)}</li>)}
                    </ul>
                    <p className="cpr-amenities__fee">{t('amenities_info')}</p>
                </div>

                <div className="cpr-amenities__grid">
                    {AMENITY_TILES.map((tile, i) => (
                        <Reveal as="figure" key={tile.image} delay={i * 80}
                                className={`cpr-amenity cpr-amenity--${tile.size}`}>
                            <div className="cpr-media">
                                <Picture name={tile.image} alt=""
                                         sizes={tile.size === 'lg' ? '(min-width: 1024px) 60vw, 100vw' : '(min-width: 1024px) 30vw, 100vw'}/>
                            </div>
                            <figcaption>{t(tile.caption)}</figcaption>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
